<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-data.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white mb--0">數字化應用開發</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">數字化應用開發</h2>
				<div style="margin-top: 48px; ">
					<p style="font-size: 18px">
						企業數字化應用開發服務旨在通過定制化軟件系統與智能化工具，協助企業實現業務流程重構、數據資產增值及營運效率提升。其核心價值包括業務線上化、數據驅動決策、快速應對市場需求，並滿足特定業務場景的應用開發與系統整合需求。
					</p>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">業務挑戰</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">業務數字化程度低</div>
										<div class="t2">
											經過多年的信息化、數字化建設，企業或組織內仍存在大量的線下業務或離線流程，無法實現企業全員、全業務在線化，企業數字化轉型缺少有效的底層平台支撐
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">業務流程不連貫</div>
										<div class="t2">
											隨著組織內各類業務系統的增多，各類業務系統間獨立性問題更加突出。組織全業務流程存在系統業務斷點，無法實現完整的全流程業務線上化，數據及應用孤立，業務操作困難
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">業務系統不夠人性化</div>
										<div class="t2">
											老舊業務系統或產品化的應用定制化服務能力弱，隨著業務及技術的發展，各類系統在人機交互、協作關聯、數據服務等方面已經無法滿足業務拓展等要求，需要更強的適配能力
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">數字化應用交付服務</div>
										<div class="t2">
											基於全代碼&低代碼的數字化應用系統開發及交付，滿足特定業務場景的應用開發及集成，提升企業業務信息化及數字化能力
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/data3-1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">客戶價值</h2>
				<div class="product">
					<div class="pic">
						<img src="@/assets/images/data3-2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">低代碼開發交付</div>
										<div class="t2">
											通過成熟的低代碼開發平台，針對流程辦公、客戶管理、採購管理、日常工作管理等業務場景，快速上線敏捷化的OA、CRM、SRM等業務應用系統，滿足業務等快速上線及敏捷適配
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">應用集成服務</div>
										<div class="t2">
											基於船水科技自研應用集成平台雲捷中間件，為客戶提供各類應用系統集成及數據交互服務，實現業務系統間的流程再造及數據交互，滿足企業全流程業務能力建設，打通應用及業務壁壘
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">產品交付服務</div>
										<div class="t2">
											針對釘釘、企微、IDaas等平台級產品提供產品的規劃、方案、交付、定制化開發等服務，實現如統一協同辦公、智能客戶服務、混合會議管理、智能數據查詢、等業務場景，實現數字化轉型
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">全代碼開發</div>
										<div class="t2">
											針對特定行業場景的全代碼開發服務，精確足滿足客戶業務服務及系統定制化需求。重點服務汽車、農業、製造業等高端高質量客戶。提供如專業管理系統、定制化門戶、業務工作台等開發落地
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
.swiper-container {
	width: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
		position: unset;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
